"use strict";

exports.__esModule = true;
exports.Pool = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Pool = exports.Pool = function () {
  function Pool(runTask, limit) {
    (0, _classCallCheck3["default"])(this, Pool);

    this.runTask = runTask;
    this.queue = [];
    this.processing = [];
    this.limit = limit;
  }

  Pool.prototype.enqueue = function enqueue(task) {
    var _this = this;

    return new _promise2["default"](function (resolve, reject) {
      _this.queue.push({
        task: task,
        resolve: resolve,
        reject: reject
      });
      _this.check();
    });
  };

  Pool.prototype.run = function run(item) {
    var _this2 = this;

    this.queue = this.queue.filter(function (v) {
      return v !== item;
    });
    this.processing.push(item);
    this.runTask(item.task).then(function () {
      _this2.processing = _this2.processing.filter(function (v) {
        return v !== item;
      });
      item.resolve();
      _this2.check();
    }, function (err) {
      return item.reject(err);
    });
  };

  Pool.prototype.check = function check() {
    var _this3 = this;

    var processingNum = this.processing.length;
    var availableNum = this.limit - processingNum;
    this.queue.slice(0, availableNum).forEach(function (item, index) {
      _this3.run(item);
    });
  };

  return Pool;
}();


//////////////////
// WEBPACK FOOTER
// ./src/pool.js
// module id = 198
// module chunks = 0